/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AnalysisCreateDto = core.serialization.object({
    field: core.serialization.string(),
    result: core.serialization.any(),
});
